"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _inputRadio = require("@citrus/input-radio");
var _inputTextfield = require("@citrus/input-textfield");
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _isNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNullOrEmpty"));
var _PctyQuestion = require("./PctyQuestion.Common");
require("./index.css");
var _div;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var PctyQuestionMultipleChoice = function PctyQuestionMultipleChoice(_ref) {
  var id = _ref.id,
    number = _ref.number,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    scenario = _ref.scenario,
    required = _ref.required,
    question = _ref.question,
    options = _ref.options,
    response = _ref.response,
    hint = _ref.hint,
    onResponse = _ref.onResponse,
    columns = _ref.columns,
    otherQuestion = _ref.otherQuestion,
    sortOrder = _ref.sortOrder;
  var _useState = (0, _react.useState)((0, _PctyQuestion.getSortedOptions)({
      array: options,
      sortOrder: sortOrder
    })),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    sortedOptions = _useState2[0],
    setSortedOptions = _useState2[1];
  var _useState3 = (0, _react.useState)(otherQuestion ? otherQuestion.value : ''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    otherOption = _useState4[0],
    setOtherOption = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    showOtherTextbox = _useState6[0],
    setShowOtherTextbox = _useState6[1];
  var selectedOption = (0, _isNotNullOrEmpty.default)(response) && (0, _isNotNullOrEmpty.default)(sortedOptions) ? sortedOptions.findIndex(function (x) {
    return x.id === response[0].optionId;
  }) : -1;
  var selectedOtherOption = (0, _isNotNullOrEmpty.default)(response) && response[0].optionId === 'otherOption';
  (0, _react.useEffect)(function () {
    setSortedOptions((0, _PctyQuestion.getSortedOptions)({
      array: options,
      sortOrder: sortOrder
    }));
    if (selectedOtherOption) {
      setShowOtherTextbox(true);
      setOtherOption(response[0].value);
    }
  }, [options, sortOrder]);
  var getSelectedIndex = function getSelectedIndex() {
    var selectedIndex = -1;
    if (!(0, _isNullOrEmpty.default)(response)) {
      if (selectedOtherOption) {
        selectedIndex = sortedOptions.length;
      }
      if (selectedOption >= 0) {
        selectedIndex = selectedOption;
      }
    }
    return selectedIndex;
  };
  var selectedIndex = getSelectedIndex();
  if (selectedIndex < 0) {
    selectedIndex = -1;
  }
  var setOtherValue = function setOtherValue(_ref2) {
    var textId = _ref2.textId,
      value = _ref2.value;
    setOtherOption(value);
    onResponse(id, [{
      optionId: 'otherOption',
      value: value
    }]);
  };
  var onChange = function onChange(_ref3) {
    var id = _ref3.id,
      index = _ref3.index,
      value = _ref3.value;
    if (readOnly) return;
    setShowOtherTextbox(value && value === 'otherOption');
    if (value === 'otherOption') {
      onResponse(id, [{
        optionId: 'otherOption',
        value: otherOption
      }]);
    } else {
      onResponse(id, [{
        optionId: value
      }]);
    }
  };
  var getListItems = function getListItems() {
    var retOptions = sortedOptions.map(function (x, index) {
      return /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
        id: "".concat(id, "-options-").concat(x.id),
        key: "".concat(id, "-options-").concat(x.id),
        value: x.id,
        automationId: "question-".concat(number, "-radio-item-").concat(index)
      }, x.value);
    });
    if (otherQuestion && otherQuestion.label && otherQuestion.enabled) {
      var otherQuestionListItem = /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
        id: "".concat(id, "-options-otherOption"),
        key: "".concat(id, "-options-otherOption"),
        value: "otherOption",
        automationId: "question-".concat(number, "-radio-item-other")
      }, otherQuestion ? otherQuestion.label : '', selectedOtherOption && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, readOnly ? /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-border-all pcty-readonly-otherfield"
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-option-no-answer",
        id: "".concat(id, "-othertext-").concat(id.toString()),
        maxLength: 500,
        disabled: disabled,
        readOnly: true,
        placeholder: otherQuestion.placeholder || 'Enter text',
        onChange: setOtherValue,
        value: otherOption,
        automationId: "question-".concat(number, "-multiple-choice-other-text"),
        wrapperStyles: {
          display: 'inline'
        }
      })) : /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-option-no-answer",
        id: "".concat(id, "-othertext-").concat(id.toString()),
        key: "".concat(id, "-othertext-").concat(id.toString()),
        maxLength: 500,
        disabled: disabled,
        placeholder: otherQuestion.placeholder || 'Enter text',
        onChange: setOtherValue,
        value: otherOption,
        automationId: "question-".concat(number, "-multiple-choice-other-text"),
        wrapperStyles: {
          display: 'inline'
        }
      })));
      retOptions.push(otherQuestionListItem);
    }
    return retOptions;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestion.renderHint)(id, hint), (0, _PctyQuestion.renderScenario)(id, scenario), (0, _PctyQuestion.renderQuestion)(id, number, question, required, readOnly), /*#__PURE__*/_react.default.createElement(_inputRadio.Radio, {
    columns: columns,
    className: selectedOtherOption ? 'pcty-question-radiolist-with-other' : 'multiple-choice',
    id: id,
    key: id,
    automationId: "question-".concat(number, "-multiple-choice-radio"),
    disabled: disabled,
    onChange: onChange,
    selectedIndex: selectedIndex
  }, getListItems()), showOtherTextbox && (_div || (_div = /*#__PURE__*/_react.default.createElement("div", null))));
};
PctyQuestionMultipleChoice.propTypes = {
  /** The number of columns in which to display the options for the component. */
  columns: _propTypes.default.number,
  /** A hint that you want to give the person answering the question. */
  hint: _propTypes.default.string,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** The question number. */
  number: _propTypes.default.number.isRequired,
  /** Whether or not the question will be disabled. */
  disabled: _propTypes.default.bool,
  /** Whether or not the question will be readOnly. */
  readOnly: _propTypes.default.bool,
  /** Whether or not the question will be displayed as required. */
  required: _propTypes.default.bool,
  /** Callback function that receives response information each time someone interacts with the question. */
  onResponse: _propTypes.default.func.isRequired,
  /** The array of option objects. */
  options: _propTypes.default.array.isRequired,
  /** The object that configures the Other field. */
  otherQuestion: _propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    enabled: _propTypes.default.bool
  }),
  /** The question text. */
  question: _propTypes.default.string.isRequired,
  /** An array of response objects that are output from the component. */
  response: _propTypes.default.array,
  /** Some text that sets up your question. */
  scenario: _propTypes.default.string,
  /** The sortOrder of the options of the component. */
  sortOrder: _propTypes.default.oneOf(['defined', 'ascending', 'descending', 'random']),
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionMultipleChoice');
  }
};
PctyQuestionMultipleChoice.defaultProps = {
  columns: 1,
  scenario: null,
  sortOrder: 'defined',
  disabled: false,
  readOnly: false,
  __TYPE: 'PctyQuestionMultipleChoice'
};
var _default = exports.default = PctyQuestionMultipleChoice;